
import Countdown from 'vux/src/components/countdown/index.vue'

import { mapState, mapActions } from 'vuex'

export default {
components: {
Countdown
},
data () {
return {
formValidated: false,
mobile: '',
verifyCode: '',
isMobileValidated: false,
timer: 60,
timerStart: false,
error: false,
message: ''
}
},
methods: {
...mapActions([
'setUser'
]),
validatedForm () {
this.isMobileValidated = this.$refs.inpBindMobile.valid
this.formValidated = this.isMobileValidated && this.verifyCode.length
},
mobileError () {
this.$vux.toast.show({
text: this.mobile.length ? '手机号码无效' : '请输入手机号'
})
},
verifyCodeError () {
this.$vux.toast.show({
text: '请输入验证码'
})
},
reloadVCodeImg () {
document.getElementById('imgVCode').src = '/verify?' + (new Date()).valueOf()
},
sendVerifyCode () {
this.message = ''
this.timerStart = true
this.$sendVerifyCode(this.mobile.replace(/\s+/g, ''), (res) => {
if (!res.success) {
this.timerStart = false
this.$vux.toast.show({
text: res.message,
width: '16em'
})
}
})
},
timerFinish () {
this.timerStart = false
},
bind () {
this.validatedForm()
if (!this.formValidated) {
return
}
this.message = ''
this.$vux.loading.show()
this.$mobile(this.mobile.replace(/\s+/g, ''), this.verifyCode, (res) => {
this.$vux.loading.hide()
if (res.success) {
this.error = false
if (res.data) {
this.setUser(res.data)
}
if (this.$route.query && this.$route.query.redirect) {
this.$router.replace({path: this.$route.query.redirect})
} else {
this.$router.push({name: 'My'})
}
} else {
this.verifyCode = ''
this.error = true
this.message = res.message
}
})
}
},
computed: {
...mapState({
user: state => state.oice.user
})
}
}



// WEBPACK FOOTER //
// ./src/pages/index/views/Mobile.vue